<template>
    <div class="con">
        <img :src="img" alt="">
        <div class="text animated fadeInUp">
        <p>{{text0}}</p>
            <p>{{text1}}</p>
        </div>
        <div class="scr">
        <span>scrool</span>
        <span></span>
    </div>
    </div>
</template>

<script>
    export default {
        name: "tbanner",
        props:['img','text0','text1']
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    position: relative;
    height:100vh;
    overflow: hidden;
    img{
        width:100%;
        height:100%;
        object-fit: cover;
        display: block;
    }
    .text{
        position: absolute;
        left:25%;
        width:50%;
        top:50%;
        color:white;
        text-align: center;
        p:nth-child(1){
            font-size: 50px;
            font-weight: bold;
        }
        p:nth-child(2){
            font-size: 20px;
            font-weight: bold;
            margin-top: 40px;
        }
    }
    .scr{
        width:10%;
        position: absolute;
        left:45%;
        bottom:0;
        z-index: 1000;
        height:120px;
        text-align: center;
        text-transform: uppercase;
        display: flex;
        flex-direction: column;
        justify-content: center;
        span:nth-child(1){
            color:white;
            padding-bottom: 10px;
            font-size: 12px;
        }
        span:nth-child(2){
            width:1px;
            height:100px;
            background-color: rgba(255,255,255,.2);
            position: relative;
            margin-left: 50%;
        }
        span:nth-child(2)::before{
            content:'';
            display: inline-block;
            width:1px;
            height:20px;
            position: absolute;
            top:30%;
            left:0;
            animation: runa 2s infinite ease;
            background-color: white;
        }
        @keyframes runa {
            from{
                top:0;
            }
            to{
                top:100%;
            }
        }
    }
    @media screen and (max-width:1279px){
        .text{
            width:80%;
            left:10%;
            p:nth-child(1){
                font-size: 35px;
            }
            p:nth-child(2){
                font-size: 20px;
                line-height: 30px;
            }
        }
    }
}
</style>